import { QuoteCountStatusRequest } from '@/main/models/request/quoteRequest';
import { QuoteResponseCount } from '@/main/models/response';

export enum ManagePackagesCountStatusTypes {
  GET_MANAGEPACKAGES_COUNT_STATUS = '@managePackagesCountStatus/GET_MANAGEPACKAGES_COUNT_STATUS',
  SAVE_MANAGEPACKAGES_COUNT_STATUS = '@managePackagesCountStatus/SAVE_MANAGEPACKAGES_COUNT_STATUS',
  RESET_REDUCER_MANAGEPACKAGES_COUNT_STATUS = '@managePackagesCountStatus/RESET_REDUCER_MANAGEPACKAGES_COUNT_STATUS'
}

export interface ManagePackagesCountStatusState {
  readonly managePackagesCountStatus: {
    data: QuoteResponseCount[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetManagePackagesCountStatus {
  type: typeof ManagePackagesCountStatusTypes.GET_MANAGEPACKAGES_COUNT_STATUS;
  payload: {
    request: QuoteCountStatusRequest;
  };
}

export interface SaveManagePackagesCountStatus {
  type: typeof ManagePackagesCountStatusTypes.SAVE_MANAGEPACKAGES_COUNT_STATUS;
  payload: {
    data: QuoteResponseCount[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerManagePackagesCountStatus {
  type: typeof ManagePackagesCountStatusTypes.RESET_REDUCER_MANAGEPACKAGES_COUNT_STATUS;
}

export type ManagePackagesCountStatusActionTypes =
  | GetManagePackagesCountStatus
  | SaveManagePackagesCountStatus
  | ResetReducerManagePackagesCountStatus;

